
import { motion } from "framer-motion";
import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import QuietSpotsMap from "../components/QuietSpotsMap";
import LocationSearchForm from "../components/LocationSearchForm";

const Spots = () => {
  const [selectedSpots, setSelectedSpots] = useState<any[]>([]);

  const handleLocationSelect = (location: any) => {
    const isAlreadySelected = selectedSpots.some(spot => spot.placeId === location.placeId);
    if (!isAlreadySelected) {
      setSelectedSpots(prev => [...prev, location]);
    }
  };

  const handleRemoveSpot = (spotId: string) => {
    setSelectedSpots(prev => prev.filter(spot => spot.id !== spotId));
  };

  const handleSubmit = (spots: any[]) => {
    const saved = localStorage.getItem('suggestedSpots');
    const existingLocations = saved ? JSON.parse(saved) : [];
    const newLocations = spots.map(spot => ({
      ...spot,
      suggestedAt: new Date().toISOString()
    }));
    const updatedLocations = [...newLocations, ...existingLocations];
    localStorage.setItem('suggestedSpots', JSON.stringify(updatedLocations));
    setSelectedSpots([]);
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <main className="pt-8">
        <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-24 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-10"
          >
            <h1 className="font-funnel text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-4">
              Find a quiet spot
            </h1>
            <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
              Cafés, hotel lobbies, parks and more — places to take calls or work in peace, curated by the qwip team.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-10"
          >
            <QuietSpotsMap />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-center"
          >
            <p className="text-muted-foreground mb-4">Know a good spot? Search and add it below:</p>
            <LocationSearchForm 
              onLocationSelect={handleLocationSelect}
              selectedSpots={selectedSpots}
              onRemoveSpot={handleRemoveSpot}
              onSubmit={handleSubmit}
            />
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Spots;
